import { database, functions } from '../firebaseApp';

const DEFAULT_LIBRARY_PAGE_SIZE = 20;

const CAAZAM_SIZE_THUMB = 'size_thumb';
const CAAZAM_SIZE_ORIG = 'size_orig';

export default class CaazamLibrary {
    constructor(authUserUid) {
        this.authUserUid = authUserUid;
        this.firebaseRefs = [];
    }

    getMedia(pageSize = DEFAULT_LIBRARY_PAGE_SIZE) {
        return this._getPaginatedMedia(`library/${this.authUserUid}`, pageSize);
    }

    subscribeToMediaAdd(callback, latestMedia) {
        return this._subscribeToMediaAdd(`library/${this.authUserUid}`, callback, latestMedia);
    }

    subscribeToMediaDeleted(callback) {
        let ref = database.ref(`library/${this.authUserUid}`);
        ref.on('child_removed', snapshot => callback(snapshot.key));
        this.firebaseRefs.push(ref);
    }

    subscribeToMediaChanged(callback) {
        let ref = database.ref(`library/${this.authUserUid}`);
        ref.on('child_changed', snapshot => callback(snapshot.val()));
        
        this.firebaseRefs.push(ref);
    }

    cancelAllSubscriptions() {
        this.firebaseRefs.forEach(ref => ref.off());
        this.firebaseRefs = [];
    }

    // accept an array of MediaUuids and return download urls for them
    getPublicUrl(forMediaUuids) {
        let imageService = functions.httpsCallable('imageService');
        return imageService({mediaUuids: forMediaUuids, request: [CAAZAM_SIZE_THUMB, CAAZAM_SIZE_ORIG] });
    }

    setMediaFavStatus(uuid,status) {
        database.ref(`library/${this.authUserUid}`).child(uuid).child('subjectFeedback/favoriteStatus').set(status);
    }

    deleteMedia(uuid) {
        database.ref(`library/${this.authUserUid}`).child(uuid).remove();
    }

    /****************** private methods ********************/

    _getPaginatedMedia(uri, pageSize, earliestEntryId = null, fetchDetails = false) {
        console.log('Fetching media from', uri, 'start at', earliestEntryId, 'page size', pageSize);
        let ref = database.ref(uri);

        //If provided we'll return entries that were posted before (and including) `earliestEntryId`.
        if (earliestEntryId) {
            ref = ref.orderByChild('dateUploaded').endAt(earliestEntryId.value, earliestEntryId.key);
        } else {
            ref = ref.orderByChild('dateUploaded');
        }

        // We're fetching an additional item as a cheap way to test if there is a next page.
        return ref.limitToLast(pageSize + 1).once('value').then(snapshot => {
            const entries = [];

            // order the result in reverse (firebase database is always ascending)
            snapshot.forEach(childSnapshot => {
                entries.unshift(childSnapshot.val());
            });

            // Figure out if there is a next page.
            let nextPage = null;
            if (entries.length > pageSize) {
                const nextPageStartingId = { value: entries[pageSize].dateUploaded, key: entries[pageSize].mediaUuid };
                entries.pop();
                nextPage = () => this._getPaginatedMedia(
                    uri, pageSize, nextPageStartingId, fetchDetails);
            }
            /*
            if (fetchDetails) {
                // Fetch details of all media.
                const queries = entryIds.map(postId => this.getPostData(postId));
                // Since all the requests are being done one the same feed it's unlikely that a single one
                // would fail and not the others so using Promise.all() is not so risky.
                return Promise.all(queries).then(results => {
                    const deleteOps = [];
                    results.forEach(result => {
                        if (result.val()) {
                            entries[result.key] = result.val();
                        } else {
                            // We encountered a deleted post. Removing permanently from the feed.
                            delete entries[result.key];
                            deleteOps.push(this.deleteFromFeed(uri, result.key));
                        }
                    });
                    if (deleteOps.length > 0) {
                        // We had to remove some deleted posts from the feed. Lets run the query again to get
                        // the correct number of posts.
                        return this._getPaginatedFeed(uri, pageSize, earliestEntryId, fetchPostDetails);
                    }
                    return { entries: entries, nextPage: nextPage };
                });
            }
            */
            return { entries: entries, nextPage: nextPage };
        });
    }

    _subscribeToMediaAdd(uri, callback, latestMedia = null) {
        let ref = database.ref(uri);
        if (latestMedia) {
            ref = ref.orderByChild('dateUploaded').startAt(latestMedia.dateUploaded, latestMedia.mediaUuid);
        } else {
            ref = ref.orderByChild('dateUploaded');
        }
        ref.on('child_added', snapshot => {
            if (snapshot.key !== latestMedia.mediaUuid) {
                let mediaObject = snapshot.val();
                mediaObject.mediaUuid = snapshot.key;
                callback(mediaObject);
            }
        });

        this.firebaseRefs.push(ref);
    }

    

}


// WEBPACK FOOTER //
// ./src/CaazamModel/CaazamLibrary.js